import '../../css/component/toast.css'
/**
 * 不依赖zepto的toast
 * @param  {string} text 
 */

var toastQueue = [];

function toast(text, timeout) {
    function whichAnimationEvent() {
        var t,
            el = document.createElement("fakeelement");

        var animations = {
            "animation": "animationend",
            "OAnimation": "oAnimationEnd",
            "MozAnimation": "animationend",
            "WebkitAnimation": "webkitAnimationEnd"
        }

        for (t in animations) {
            if (el.style[t] !== undefined) {
                return animations[t];
            }
        }
    }
    var animationEvent = whichAnimationEvent();
    timeout = timeout || 3000;
    toastQueue.push({
        text: text,
        timeout: timeout
    })
    function showToast() {
        var toastDiv = document.querySelector('.m-toast');
        if(toastDiv) return;
        var toastItem = toastQueue.shift();
        toastDiv = document.createElement('div');
        toastDiv.innerText = toastItem.text;
        toastDiv.classList.add('m-toast', 'fadeIn');
        setTimeout(function () {
            toastDiv.classList.remove('fadeIn');
            toastDiv.classList.add('fadeOut');
            toastDiv.addEventListener(animationEvent, function () {
                toastDiv&&toastDiv.parentNode.removeChild(toastDiv);
                toastDiv = null;
                if(toastQueue.length){
                    showToast();
                }
            })
        }, toastItem.timeout)
        document.body.appendChild(toastDiv);
    }
    showToast();
}

export default toast